import Link from 'next/link';
import Image from 'next/image';
import logoPartner from '../images/footer-anacle-logo-partner.svg';
import logo from '../images/footer-anacle-logo.svg';
import { usePathname } from 'next/navigation';
import {
  ImFacebook2,
  ImInstagram,
  ImLinkedin,
  ImYoutube,
} from 'react-icons/im';

// Add the Footer to the bottom of your landing page and more.
// The support link is connected to the config.js file. If there's no config.mailgun.supportEmail, the link won't be displayed.
const ExploreAnacleList = [
  { name: 'Our Technologies', href: 'https://anacle-website.vercel.app/' },
  {
    name: 'Anacle Leadership',
    href: 'https://anacle-website.vercel.app/about-us#anacle-leadership',
  },
  {
    name: 'Investor Relations',
    href: 'https://anacle-website.vercel.app/investor-relations',
  },
  {
    name: 'Financial Reports',
    href: 'https://anacle-website.vercel.app/financial-reports',
  },
  {
    name: 'Announcements',
    href: 'https://anacle-website.vercel.app/announcements',
  },
  { name: 'Media Room', href: 'https://anacle-website.vercel.app/media-room' },
  {
    name: 'Careers with Anacle',
    href: 'https://anacle-website.vercel.app/careers',
  },
];

const ProductList = [
  {
    name: 'Simplicity® Business Software',
    href: '/',
  },
  {
    name: 'Simplicity® Real Estate',
    href: '/real-estate',
  },
  {
    name: 'Simplicity® Digital Workplace',
    href: '/digital-workplace',
  },
  {
    name: 'Simplicity® Utilities',
    href: '/utilities',
  },
  { name: 'Simplicity® IoT', href: '/iot' },
  { name: 'Tesseract®', href: 'https://tesseract.anacle.com/' },
];

const partnerList = [
  {
    name: 'Our Simplicity Partner Network',
    href: '/partners/partner-network',
  },
  {
    name: 'Our Channel Partner Programs',
    href: '/partners/channel-partner-programs',
  },
  {
    name: 'Preferred VAR',
    href: '/partners/preferred-var',
  },
  {
    name: 'Authorised VAR',
    href: '/partners/authorised-var',
  },
  {
    name: 'Exclusive VAR',
    href: '/partners/exclusive-var',
  },
  {
    name: 'Professional Services Providers',
    href: '/partners/professional-services-providers',
  },
];

const Footer = () => {
  const pathname = usePathname();
  const isPartnersPage = pathname.startsWith('/partners');
  return (
    <footer className="bg-lightGray py-12 mt-8 mx-auto px-8">
      <section className="max-w-8xl grid grid-cols-4 gap-4 mx-auto">
        <div className="col-span-3">
          <Link href="https://anacle-website.vercel.app/">
            <Image
              className="w-auto h-auto"
              src={isPartnersPage ? logoPartner : logo}
              alt="Anacle Systems"
              width="140"
              height="41"
            />
          </Link>
        </div>
      </section>
      <section className="max-w-8xl grid md:grid-cols-3 lg:grid-cols-4 gap-4 mx-auto mt-6">
        <div className="hidden lg:block col-span-1"></div>
        <div className="col-span-1">
          <h5
            className={`font-bold pb-4 text-lg ${
              isPartnersPage ? 'text-[#BF984D]' : 'text-[#000000]'
            } ${isPartnersPage ? '' : 'group-hover:text-[#000000]'} transition-colors duration-200`}
          >
            Explore Anacle
          </h5>
          <ul className="text-sm">
            {(ExploreAnacleList || []).map((item) => {
              return (
                <li
                  key={item.name}
                  className="pb-3 hover:text-[#000000] transition-colors duration-200"
                >
                  <Link href={item.href}>{item.name}</Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="col-span-1">
          <h5
            className={`font-bold pb-4 text-lg ${
              isPartnersPage ? 'text-[#BF984D]' : 'text-[#000000]'
            } ${isPartnersPage ? '' : 'group-hover:text-red-500'} transition-colors duration-200`}
          >
            Products
          </h5>
          <ul className="text-sm">
            {(ProductList || []).map((item) => {
              return (
                <li
                  key={item.name}
                  className="pb-3 hover:text-[#000000] transition-colors duration-200"
                >
                  <Link
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>

          <h5
            className={`font-bold pb-4 text-lg mt-12 ${
              isPartnersPage ? 'text-[#BF984D]' : 'text-[#000000]'
            } ${isPartnersPage ? '' : 'group-hover:text-red-500'} transition-colors duration-200`}
          >
            Partners
          </h5>
          <ul className="text-sm">
            {partnerList.map((item) => {
              return (
                <li
                  key={item.name}
                  className="pb-3 hover:text-[#000000] transition-colors duration-200"
                >
                  <Link href={item.href}>{item.name}</Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="col-span-1">
          <h5
            className={`font-bold pb-4 text-lg ${
              isPartnersPage ? 'text-[#BF984D]' : 'text-[#000000]'
            } ${isPartnersPage ? '' : 'group-hover:text-red-500'} transition-colors duration-200`}
          >
            Locations
          </h5>
          <p className="text-sm">
            3 Fusionopolis Way, #14-21, Symbiosis, <br />
            Singapore 138633
          </p>
          <p className="flex gap-2 mt-4">
            <Link href="https://www.linkedin.com/company/anacle-systems/">
              <ImLinkedin
                className={`${isPartnersPage ? 'text-[#BF984D]' : 'text-[#373737]'} w-8 h-8 rounded-m`}
              />
            </Link>
            <Link href="https://www.facebook.com/AnacleSystems/">
              <ImFacebook2
                className={`${isPartnersPage ? 'text-[#BF984D]' : 'text-[#373737]'} w-8 h-8 rounded-m`}
              />
            </Link>
            <Link href="https://www.instagram.com/lifeatanacle/">
              <ImInstagram
                className={`${isPartnersPage ? 'text-[#BF984D]' : 'text-[#373737]'} w-8 h-8 rounded-m`}
              />
            </Link>
            <Link href="https://www.youtube.com/channel/UCJaI93IYlEItP_pncdY47Bw">
              <ImYoutube
                className={`${isPartnersPage ? 'text-[#BF984D]' : 'text-[#373737]'} w-8 h-8 rounded-m`}
              />
            </Link>
          </p>
          <ul className="text-sm mt-10">
            <li className="pb-3">
              <Link href="https://anacle-website.vercel.app/contact-us/">
                Contact Us
              </Link>
            </li>
            <li className="pb-3">
              <Link href="https://anacle.com/privacy-policy/">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
